/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */

import { PaletteOptions } from "@mui/material/styles";

const basicThemePalette: PaletteOptions = {
	text: {
		primary: "#111111",
		disabled: "#5B5E68",
	},
	primary: {
		main: "#005670", // Nav-bar background
	},
	secondary: {
		main: "#ABC7CA",
		// @ts-ignore
		secondary: "#34657F"// underlines, activated borders, , submit/confirmation buttons
	},
	success: {
		main: "#BCD546", // success pop-ups, selection tick buttons
	},
	info: {
		main: "#1D2155", // wait spinners
	},
	background: {
		// By default there is a very light background (250, 250, 250)
		default: "#ffffff",
	},
};

export default basicThemePalette;
